import { FormikProvider, Form, Field } from 'formik';
import useUserForm from '../../hooks/useUserForm';
import Checkbox1 from '../ui-control/Checkbox1';
import XInput from '../common/XInput';
import XSearchMultiSelect from '../common/XSearchMultiSelect';
import XLoader from '../common/XLoader';
import XModal from '../common/XModal';

const formRowClasses = "grid grid-cols-1 md:grid-cols-2 gap-x-6 pt-4";
const formGroupClasses = "mb-4";
const fullColumnClasses = "md:col-span-2";
const teamsBoxClasses = "p-3 border border-border rounded";
const adminColumnClasses = "md:col-span-2 mt-4";

const UserForm = ({ isOpen, title, onClose, onSubmit, isFormSubmitting, selectedUserId }) => {
    const { formik, teams, onSearch, getErrorMessage, isLoadingUser } = useUserForm({ selectedUserId, onSubmit });

    return (
        <XModal
            isOpen={isOpen}
            title={title}
            onClose={onClose}
            onSubmit={formik.handleSubmit}
            submitText="Save"
            isSubmitting={isFormSubmitting}
            size="lg"
        >
            {isLoadingUser ? (
                <XLoader />
            ) : (
                <FormikProvider value={formik}>
                    <Form>
                        <div className={formRowClasses}>
                            <div className={formGroupClasses}>
                                <XInput
                                    name="firstName"
                                    placeholder="Enter First Name"
                                    label="First Name"
                                    {...formik.getFieldProps('firstName')}
                                    error={getErrorMessage('firstName')}
                                />
                            </div>

                            <div className={formGroupClasses}>
                                <XInput
                                    name="lastName"
                                    placeholder="Enter Last Name"
                                    label="Last Name"
                                    {...formik.getFieldProps('lastName')}
                                    error={getErrorMessage('lastName')}
                                />
                            </div>

                            <div className={formGroupClasses}>
                                <XInput
                                    name="email"
                                    placeholder="Enter Email"
                                    label="Email"
                                    {...formik.getFieldProps('email')}
                                    error={getErrorMessage('email')}
                                />
                            </div>

                            <div className={formGroupClasses}>
                                <XInput
                                    name="mobileNumber"
                                    placeholder="Enter Mobile Number"
                                    label="Mobile Number"
                                    {...formik.getFieldProps('mobileNumber')}
                                />
                            </div>

                            <div className={formGroupClasses}>
                                <XInput
                                    name="password"
                                    type="password"
                                    placeholder="Enter Password"
                                    label="Password"
                                    {...formik.getFieldProps('password')}
                                    error={getErrorMessage('password')}
                                />
                            </div>

                            <div className={formGroupClasses}>
                                <XInput
                                    name="confirmPassword"
                                    type="password"
                                    placeholder="Confirm Password"
                                    label="Confirm Password"
                                    {...formik.getFieldProps('confirmPassword')}
                                    error={getErrorMessage('confirmPassword')}
                                />
                            </div>

                            <div className={fullColumnClasses}>
                                <div className={teamsBoxClasses}>
                                    <XSearchMultiSelect
                                        label="Teams"
                                        value={formik.values.teamIds}
                                        onChange={(next) => formik.setFieldValue('teamIds', next)}
                                        items={teams}
                                        onSearch={onSearch}
                                        getItemLabel={(t) => t.name}
                                    />
                                </div>
                            </div>

                            <div className={adminColumnClasses}>
                                <div className={formGroupClasses}>
                                    <Field
                                        name="isAdmin"
                                        label="Admin"
                                        position="left"
                                        component={Checkbox1}
                                    />
                                </div>
                            </div>
                        </div>
                    </Form>
                </FormikProvider>
            )}
        </XModal>
    );
};

export default UserForm;
